/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Form from "../../shared/forms/Form";
import Field from "../../shared/forms/Field";
import useForm from "../../shared/forms/useForm";
import { Button } from "primereact/button";
import useApiMovimientos from "../../api/administracion/useApiMovimientos";
import moment from "moment";
import GastosMovimientos from "./GastosMovimientos";
import CompensacionMovimientos from "./CompensacionMovimientos";
import DescuentoMovimiento from "./DescuentoMovimiento";
import FormDropDown from "../../shared/forms/FormFields/FormDropDown";
import FormTextArea from "../../shared/forms/FormFields/FormTextArea";
import ReadOnlyProvider from "../../shared/forms/ReadOnlyProvider";
import { TabPanel, TabView } from "primereact/tabview";
import ExGrid from "../../shared/Grid/ExGrid";
import ExColumn from "../../shared/Grid/ExColumn";
import { fechaUtc } from "../../shared/Grid/GridCellRenderers";
import _ from "lodash";

import GastosMovimientoPorComprobar from "./GastosMovimientoPorComprobar";

const initialValues = {
  solicitudDeGastos: {
    fecha: moment().startOf("day")._d,
  },
};

const DetalleMovimientos = ({
  movimientoId,
  cajaId,
  onCancel,
  onSaved,
  soloLectura,
}) => {
  const [submitted, setSubmitted] = useState(false);
  const api = useApiMovimientos();

  initialValues.cajaId = cajaId;

  const {
    values: solicitud,
    setValues,
    onChange,
    onValidate,
    isValid,
  } = useForm(initialValues);

  useEffect(() => {
    setSubmitted(false);
    load(movimientoId).then();
  }, [movimientoId]);

  const load = async (movimientoId) => {
    const result = await api.obtener(movimientoId);

    if (result?.gastoUrl?.url) {
      result.gastoUrl.urls = result.gastoUrl.url.split("|").filter(Boolean);
    }

    result.gastos = (result.gastos ?? []).map((gasto) => ({
      ...gasto,
      comprobantes: gasto.comprobantes ?? [],
      montoComprobado: gasto.montoComprobado ?? gasto.comprobado ?? 0,
      comprobado: gasto.comprobado ?? gasto.montoComprobado ?? 0,
      collapsed: gasto.collapsed ?? false,
    }));

    setValues(result);
  };

  const onSave = async () => {
    setSubmitted(true);

    if (!isValid) {
      return;
    }

    await onSaveComprobantes();
  };

  const getExtensionFromUrl = (url = "") => {
    const cleanUrl = url.split("?")[0];
    const parts = cleanUrl.split(".");
    return parts.length > 1 ? parts.pop().toLowerCase() : undefined;
  };

  const onSaveComprobantes = async () => {
    const formData = new FormData();

    const gastos = solicitud.gastos ?? [];
    const archivosPendientes = [];

    gastos.forEach((gasto, gastoIndex) => {
      (gasto.comprobantes ?? []).forEach((comprobante, comprobanteIndex) => {
        const file = comprobante?.comprobante?.file;

        if (file) {
          archivosPendientes.push({
            gastoIndex,
            comprobanteIndex,
          });

          formData.append("files", file);
        }
      });
    });

    let fileUrls = [];

    if (archivosPendientes.length > 0) {
      const res = await api.archivoGasto(movimientoId, formData);
      fileUrls = res?.fileUrls ?? [];
    }

    let fileUrlIndex = 0;

    const gastosActualizados = gastos.map((gasto) => {
      const comprobantes = (gasto.comprobantes ?? []).map((comprobante) => {
        const comprobanteArchivo = comprobante?.comprobante;

        if (!comprobanteArchivo) {
          return comprobante;
        }

        const { file, ...comprobanteSinFile } = comprobanteArchivo;

        let url = comprobanteSinFile.url;

        if (file) {
          url = fileUrls[fileUrlIndex++] ?? url;
        }

        return {
          ...comprobante,
          comprobante: {
            ...comprobanteSinFile,
            url,
            urls: url ? [url] : comprobanteSinFile.urls,
            extension:
              comprobanteSinFile.extension ?? getExtensionFromUrl(url),
          },
        };
      });

      const comprobado = _.sumBy(comprobantes, (x) =>
        Number(x?.monto ?? 0)
      );

      return {
        ...gasto,
        comprobantes,
        comprobado,
        montoComprobado: comprobado,
      };
    });

    const urlsComprobantes = gastosActualizados.flatMap((gasto) =>
      (gasto.comprobantes ?? [])
        .map((x) => x?.comprobante?.url)
        .filter(Boolean)
    );

    const urlsActuales = solicitud.gastoUrl?.urls ?? [];

    const urls = [...new Set([...urlsActuales, ...urlsComprobantes])];

    const payload = {
      ...solicitud,
      gastos: gastosActualizados,
      comprobado: _.sumBy(gastosActualizados, (x) =>
        Number(x?.comprobado ?? 0)
      ),
      urls,
      url: urls.join("|"),
      gastoUrl: {
        ...(solicitud.gastoUrl ?? {}),
        urls,
        url: urls.join("|"),
      },
    };

    await api.actualizarComprobado(movimientoId, payload);

    const comprobantesPayload = gastosActualizados.flatMap((gasto) =>
      (gasto.comprobantes ?? []).map((comprobante) => ({
        id: comprobante.id ?? comprobante.movimientoComprobanteId ?? 0,
        movimientoId,
        descripcion: comprobante.descripcion,
        monto: Number(comprobante.monto ?? 0),
        comprobanteUrl:
          comprobante?.comprobanteUrl ??
          comprobante?.comprobante?.url ??
          comprobante?.comprobante?.urls?.[0] ??
          null,
      }))
    );

    await api.guardarComprobantes(movimientoId, comprobantesPayload);
    onSaved();
  };

  return (
    <>
      <TabView>
        <TabPanel header={"Movimiento"}>
          <ReadOnlyProvider defaultReadOnly={soloLectura}>
            <Form
              columns={1}
              values={solicitud}
              width={"100%"}
              onChange={onChange}
              onValidate={onValidate}
              submitted={submitted}
              className={`form-container full-height full-width ${
                submitted ? "submitted" : ""
              }`}
            >
              <h5 style={{ gridColumnEnd: "span 2" }}>Movimiento</h5>

              <Field
                label="Empleado"
                field={"empleado"}
                disabled="true"
                source="empleados"
                cols={2}
                render={FormDropDown}
                required={true}
              />

              {solicitud?.tipoGasto && (
                <Field
                  field="gastosMovimientos"
                  cols={2}
                  render={() => (
                    <GastosMovimientos value={solicitud} cols={2} />
                  )}
                />
              )}

              {solicitud?.tipoCompensaciones && (
                <Field
                  field="compensacionMovimientos"
                  cols={2}
                  render={() => <CompensacionMovimientos value={solicitud} />}
                />
              )}

              {solicitud?.tipoDescuentos && (
                <Field
                  field="descuentoMovimiento"
                  cols={2}
                  render={() => <DescuentoMovimiento value={solicitud} />}
                />
              )}

              <Field
                label="Nota"
                field={"nota"}
                disabled="true"
                cols={2}
                rows={4}
                required={true}
                render={FormTextArea}
              />
                <h5 style={{gridColumnEnd:'span 3'}}>
                    Gastos por Comprobar
                </h5>
              {solicitud?.tipoGasto && (
                <Field
                  field="gastos"
                  cols={2}
                  render={(props) => (
                    <GastosMovimientoPorComprobar
                      {...props}
                      value={solicitud.gastos ?? []}
                      formDisabled={soloLectura || props.formDisabled}
                    />
                  )}
                />
              )}

              {solicitud?.tipoGasto && !soloLectura && (
                <div className="form-footer" style={{ gridColumnEnd: "span 2" }}>
                  <Button
                    label="Guardar"
                    className="p-button-outlined"
                    type="button"
                    onClick={onSave}
                  />
                </div>
              )}
            </Form>
          </ReadOnlyProvider>
        </TabPanel>

        <TabPanel header={"Historial"}>
          <ExGrid data={solicitud.historial ?? []}>
            <ExColumn title={"Accion"} field={"accion"} />
            <ExColumn title={"Usuario"} field={"auditUser"} />
            <ExColumn
              title={"Fecha"}
              field={"fechaUtc"}
              cellRenderer={fechaUtc}
            />
            <ExColumn title={"Comentarios"} field={"comentarios"} />
          </ExGrid>
        </TabPanel>
      </TabView>
    </>
  );
};

export default DetalleMovimientos;
